import type { AuthStep } from '@/features/authorization/types/step';

export const AuthRoute = {
  Login: 'login',
  Registration: 'registration',
  InvalidVersion: 'invalid-version',
  RequiredAction: 'required-action',
  Error: 'error'
} as const;

export type AuthRoute = (typeof AuthRoute)[keyof typeof AuthRoute];

export type AuthParam = {
  [AuthRoute.Login]: undefined;
  [AuthRoute.Registration]?: { step: AuthStep };
  [AuthRoute.InvalidVersion]?: undefined;
  [AuthRoute.RequiredAction]?: undefined;
  [AuthRoute.Error]?: undefined;
};
